// extracted by mini-css-extract-plugin
export default {"contract":"style_contract__TY0Wx"};